module.exports = __webpack_public_path__ + "static/media/forrest.bf57bfdf.png";